/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type DeleteShiftSignupMutationVariables = Types.Exact<{
  event_attendee_id: Types.Scalars["Int"];
  shift_id: Types.Scalars["Int"];
}>;

export type DeleteShiftSignupMutation = {
  deleteShiftSignup: Pick<Types.Success, "status">;
};

export const DeleteShiftSignupDocument = gql`
  mutation DeleteShiftSignup($event_attendee_id: Int!, $shift_id: Int!) {
    deleteShiftSignup(
      where: {
        AND: [
          { event_attendee_id: { equals: $event_attendee_id } }
          { shift_id: { equals: $shift_id } }
        ]
      }
    ) {
      status
    }
  }
`;

/**
 * __useDeleteShiftSignupMutation__
 *
 * To run a mutation, you first call `useDeleteShiftSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShiftSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShiftSignupMutation, { data, loading, error }] = useDeleteShiftSignupMutation({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *      shift_id: // value for 'shift_id'
 *   },
 * });
 */
export function useDeleteShiftSignupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteShiftSignupMutation,
    DeleteShiftSignupMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteShiftSignupMutation,
    DeleteShiftSignupMutationVariables
  >(DeleteShiftSignupDocument, baseOptions);
}
export type DeleteShiftSignupMutationHookResult = ReturnType<
  typeof useDeleteShiftSignupMutation
>;
export type DeleteShiftSignupMutationResult =
  ApolloReactCommon.MutationResult<DeleteShiftSignupMutation>;
export type DeleteShiftSignupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteShiftSignupMutation,
    DeleteShiftSignupMutationVariables
  >;
